export const DELIVERY_METHOD_TITLE = Object.freeze({
    ACH: 'ACH Bank Transfer',
    CHECK: 'Paper Check',
    WIRE: 'Wire Transfer'
})